import {makeEnumTypeGuard} from '../../../../../libs/shared/core/src/models/api/types/enumTypes';

export function computeInitialDropdownSelection<T extends {[key: string]: string}>(
  enumObject: T,
  value: string | undefined,
) {
  if (!value) {
    return undefined;
  }

  // Only pre-populate the value if it matches the enum options.
  // (The server does not enforce dropdown's types beyond it being a string/number or null).
  const isEnumValue = makeEnumTypeGuard(enumObject);
  if (!isEnumValue(value)) {
    return undefined;
  }

  return value;
}
